export default "__VITE_ASSET__BgXKL$ds__"